module.exports = __webpack_public_path__ + "img/marginGroup.f823362e.png";